import { TOAST_DURATION } from '@/constants'
import LayoutBasic from '@/components/LayoutBasic/LayoutBasic.vue'
import { JSConn } from '@/utilities/js-conn.js'
import { mapGetters } from 'vuex'

export default {
  name: 'OtherIncomeList',
  components: {
    LayoutBasic
  },
  data () {
    return {
      isPaginated: true,
      isPaginationSimple: false,
      defaultSortDirection: 'asc',
      currentPage: 1,
      perPage: 25
    }
  },
  computed: {
    ...mapGetters([
      'otherIncomeItemsList'
    ])
  },
  methods: {
    deleteOtherIncomeItem (id) {
      const jsConn = new JSConn()
      jsConn.toRoutePath = '/other-income'

      jsConn.formParams = {
        id: id
      }

      this.$store.dispatch('deleteOtherIncomeItem', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-warning',
            duration: TOAST_DURATION
          })
        })
    }
  }
}
